import React from 'react';

// Flacon de parfum elegant — desen vectorial custom (nu lucide)
export const PerfumeIcon = ({ className = '' }) => (
  <svg viewBox="0 0 32 32" fill="none" className={className} aria-hidden="true">
    {/* capac */}
    <rect x="13" y="2" width="6" height="4.2" rx="1.4" fill="currentColor" />
    {/* gat */}
    <rect x="14.3" y="6" width="3.4" height="3" fill="currentColor" opacity="0.85" />
    {/* corp flacon */}
    <path
      d="M10.4 12.2c0-1.7 1.4-3.1 3.1-3.1h4.9c1.8 0 3.2 1.4 3.2 3.1v2.1c1.6 1.1 2.6 2.9 2.6 5v5.4c0 2.3-1.9 4.2-4.2 4.2h-8.2c-2.3 0-4.2-1.9-4.2-4.2v-5.4c0-2.1 1-3.9 2.6-5v-2.1Z"
      fill="currentColor"
      opacity="0.22"
    />
    <path
      d="M10.4 12.2c0-1.7 1.4-3.1 3.1-3.1h4.9c1.8 0 3.2 1.4 3.2 3.1v2.1c1.6 1.1 2.6 2.9 2.6 5v5.4c0 2.3-1.9 4.2-4.2 4.2h-8.2c-2.3 0-4.2-1.9-4.2-4.2v-5.4c0-2.1 1-3.9 2.6-5v-2.1Z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
    {/* eticheta */}
    <rect x="12.4" y="19" width="7.2" height="6" rx="1.2" fill="currentColor" opacity="0.9" />
    {/* pulverizator */}
    <path d="M21.6 5.6h2.9a1.6 1.6 0 0 1 1.6 1.6v2.5" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    {/* jet de parfum */}
    <circle cx="28.6" cy="6" r="1.1" fill="currentColor" />
    <circle cx="27.2" cy="2.8" r="0.8" fill="currentColor" opacity="0.8" />
    <circle cx="30.2" cy="10.1" r="0.8" fill="currentColor" opacity="0.6" />
  </svg>
);

export default PerfumeIcon;
